export default "__VITE_ASSET__B3Qjq0qA__"